import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { useIsMobile } from '../../../hooks/useIsMobile';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import './style.css'

export const SectionSupportModules = () => {

    const isMobile = useIsMobile()

    return (
        <div className='section'>
            <div className={`section-support-container ${isMobile ? 'section-support-container-mobile' : ''}`}>
                <div className='section-support-cartel'>
                    <div className='section-support-cartel-header'>
                        <h4>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_TITLE_1)}</h4>
                        <p>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_DESCRIPTION_1)}</p>
                    </div>
                    <div className='section-support-cartel-body'>
                        <img src={IMAGES_PATH.IMAGE_DOODLE_1} alt="Support Icon" />
                    </div>
                    <div className='section-support-cartel-footer'>
                        <h4><h4 className='text-blue'>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_1_1)}</h4> {t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_1_2)}</h4>
                    </div>
                </div>
                <div className='section-support-cartel'>
                    <div className='section-support-cartel-header'>
                        <h4>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_TITLE_2)}</h4>
                        <p>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_DESCRIPTION_2)}</p>
                    </div>
                    <div className='section-support-cartel-body'>
                        <img src={IMAGES_PATH.IMAGE_DOODLE_2} alt="Support Icon" />
                    </div>
                    <div className='section-support-cartel-footer'>
                        <h4><h4 className='text-blue'>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_2_1)}</h4> {t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_2_2)}</h4>
                    </div>
                </div>
                <div className='section-support-cartel'>
                    <div className='section-support-cartel-header'>
                        <h4>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_TITLE_3)}</h4>
                        <p>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_DESCRIPTION_3)}</p>
                    </div>
                    <div className='section-support-cartel-body'>
                        <img src={IMAGES_PATH.IMAGE_DOODLE_3} alt="Support Icon" />
                    </div>
                    <div className='section-support-cartel-footer'>
                        <h4><h4 className='text-blue'>{t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_3_1)}</h4> {t(TEXT_KEYS.SUPPORT_MODULE_CARTEL_FOOTER_3_2)}</h4>
                    </div>
                </div>
            </div>
        </div>
    );
};